import { Box, Flex } from '@chakra-ui/react'
import React from 'react'

const OurOffice = () => {
  return (
    <Flex
        px={{md: 'inherit', '2xl': "19%", base: 4}}
        py={{'2xl' :20, base: 10}}
        overflow={'hidden'}
        position={'relative'}
    >
        <Box w={'full'} rounded={28}>

        </Box>
    </Flex>
  )
}

export default OurOffice